export enum WinnerConfigEnum{
    OWNER,
    LUCKY_NUMBER
}
